import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
import { LessonService } from '@/Module/Lesson/Service';
import type { ITeacher } from '@/Module/Teacher/Model/DataModel';

export const getTeacherByLessonIdAction = createAsyncThunk<ITeacher, ILessonSection['id']>(
  'lesson/getTeacherByLessonId',
  async (lessonId, { signal }) => {
    return LessonService.getTeacherByLessonId(
      {
        lessonId,
        pageCount: 1,
        pageNo: 0,
      },
      signal,
    ).then(({ data: { data } }) => data?.[0] ?? null);
  },
);
